<template>
  <BuilderWrapper
    title="Hollow Bubbles"
    helpful-tip="You can use hollow bubbles to display negative values or distinguish between binary categories eg income vs expense, capex vs opex."
  >
    <LabelledInput>
      <b-radio-group
        v-model="display"
        :options="options"
        stacked
      >
        <CategoryType :display="display" />
      </b-radio-group>
    </LabelledInput>

    <BorderWidth />
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import CategoryType from '@/components/builder/HollowBubbles/CategoryType.vue'
import BorderWidth from '@/components/builder/HollowBubbles/BorderWidth.vue'
import { HollowBubbleDisplays } from '@/types'
import { HOLLOW_BUBBLES_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
  CategoryType,
  BorderWidth,
}

@Component({ components })
export default class HollowBubbles extends Vue {
  options = [
    { value: HollowBubbleDisplays.NONE, text: 'Do not show hollow bubbles' },
    { value: HollowBubbleDisplays.NEGATIVE, text: 'Show hollow bubbles for negative values' },
    { value: HollowBubbleDisplays.POSITIVE, text: 'Show hollow bubbles for positive values' },
  ]

  NONE = HollowBubbleDisplays.NONE

  get display () {
    return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].display
  }

  set display (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'display'],
      value: newValue,
    })
  }
}

</script>
